module.exports = __webpack_public_path__ + "img/football_dribbling_card.058367f4.svg";